import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { createWidget } from '@typeform/embed';
import '@typeform/embed/build/css/widget.css';

const TypeformRedirect = () => {
  const containerRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (containerRef.current) {
      createWidget('ZH4dXx8d', {
        container: containerRef.current,
        opacity: 0,
        hideHeaders: true,
        hideFooter: true,
      });
    }
  }, []);

  return (
    <div className="min-h-screen bg-[#F9FBF5] flex flex-col">
      {/* Minimal header */}
      <div className="sticky top-0 z-40 flex w-full items-center justify-between bg-white px-6 sm:px-8 border-b border-gray-100" style={{ height: '64px' }}>
        <button onClick={() => navigate('/')} className="flex items-center gap-2">
          <div className="h-[30px] w-[30px] sm:h-[34px] sm:w-[34px] bg-[#082900] rounded-lg flex items-center justify-center">
            <span className="text-white font-bold text-lg sm:text-xl">M</span>
          </div>
        </button>
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-900 transition-colors"
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-4 h-4">
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
          </svg>
          Close
        </button>
      </div>

      {/* Typeform embedded full-page */}
      <div
        ref={containerRef}
        className="flex-1 w-full"
        style={{ minHeight: 'calc(100vh - 64px)' }}
      />
    </div>
  );
};

export default TypeformRedirect;
